// components/ContactModal.js
import React from 'react';
import { X } from 'lucide-react';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex  justify-end h-full p-4">
      <div className="bg-[#1c1c1c] text-white w-full max-w-6xl p-10 rounded-lg relative overflow-y-auto max-h-screen">
        {/* Close Button */}
        <button onClick={onClose} className="absolute top-5 right-5 text-white">
          <X size={28} />
        </button>

        <h2 className="text-4xl mb-10">Contact Us</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/* Form */}
          <div className="md:col-span-2 space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <input className="bg-transparent border-b outline-none border-white p-2" placeholder="First Name *" />
              <input className="bg-transparent border-b outline-none border-white p-2" placeholder="Last Name *" />
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <input className="bg-transparent border-b outline-none border-white p-2" placeholder="Email *" />
              <input className="bg-transparent border-b outline-none border-white p-2" placeholder="Phone" />
            </div>
            <textarea className="bg-transparent border-b outline-none border-white p-2 w-full" rows="4" placeholder="Message" />
            <button className="mt-4 px-6 py-2 bg-white text-black font-bold rounded">Send Message</button>
          </div>
          {/* Contact Info */}  
          <div className="space-y-6 text-sm">
            <div>
              <h4 className="font-bold">Call Us</h4>
              <p>+91 8309079880</p>
            </div>
            <div>
              <h4 className="font-bold">Email Us</h4>
              <p>rdsenclave</p>
            </div>
            <div>
              <h4 className="font-bold">Our Location</h4>
              <p>
                A kaspa, to, Ahmedi Nagar, Somalapuram, <br />
                 Ambur, Tamil Nadu - 635802
              </p>
            </div>
            <div>
              <h4 className="font-bold">Connect with Us</h4>
              <p><a href="#" className="underline">Instagram</a></p>
              <p><a href="#" className="underline">Facebook</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
